import { toArray } from "lodash";

type HookCallback = ((text: string) => string) | ((text: string) => void);

export function interceptStdStreams(
    stdoutIntercept: HookCallback,
    stderrIntercept: HookCallback = stdoutIntercept
): () => void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const old_stdout_write = process.stdout.write;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const old_stderr_write = process.stderr.write;

    /* eslint-disable */
    // @ts-ignore
    process.stdout.write = (function(write) {
        return function(string: any, encoding: any, fd: any): any {
            const args = toArray(arguments);
            args[0] = interceptor(string, stdoutIntercept);
            // @ts-ignore
            write.apply(process.stdout, args);
        };
    })(process.stdout.write);

    // @ts-ignore
    process.stderr.write = (function(write) {
        return function(string: any, encoding: any, fd: any) {
            const args = toArray(arguments);
            args[0] = interceptor(string, stderrIntercept);
            // @ts-ignore
            write.apply(process.stderr, args);
        };
    })(process.stderr.write);

    /* eslint-enable */

    function interceptor(str: string, callback: HookCallback): string {
        // only intercept the string
        const result = callback(str);
        if (typeof result === "string") {
            return result.replace(/\n$/, "") + (result && /\n$/.test(str) ? "\n" : "");
        }
        return str;
    }

    return function unhook(): void {
        process.stdout.write = old_stdout_write;
        process.stderr.write = old_stderr_write;
    };
}
